import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGift = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 28,
	viewBox: "0 0 25 28",
	fill: "var(--main-color)",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		opacity: .01,
		x: 24.9712,
		y: 27.875,
		width: 24,
		height: 27,
		transform: "rotate(180 24.9712 27.875)",
		fill: "var(--main-color)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.1714 8.75069H19.7814C19.9012 8.39061 19.9655 8.01013 19.9714 7.62569C19.9277 5.72073 18.5249 4.21294 16.8314 4.25069C15.203 4.29026 13.7233 5.32529 12.9714 6.95069C12.2195 5.32529 10.7398 4.29026 9.1114 4.25069C7.41787 4.21294 6.01507 5.72073 5.9714 7.62569C5.97731 8.01013 6.04157 8.39061 6.1614 8.75069H5.7714C5.23989 8.80747 4.75063 9.10097 4.41254 9.56583C4.07446 10.0307 3.91562 10.6283 3.9714 11.2257V15.2757C3.875 16.3998 4.50603 17.441 5.4714 17.7507V22.6669C5.53558 23.7278 6.33689 24.5396 7.2814 24.5007H18.6614C19.6206 24.5388 20.4281 23.7006 20.4714 22.6219V17.7507C21.4368 17.441 22.0678 16.3998 21.9714 15.2757V11.2257C22.0272 10.6283 21.8683 10.0307 21.5303 9.56583C21.1922 9.10097 20.7029 8.80747 20.1714 8.75069ZM19.9714 11.2257V15.2757C19.9834 15.3501 19.9834 15.4263 19.9714 15.5007H13.9714V11.0007H19.9714C19.9834 11.0751 19.9834 11.1513 19.9714 11.2257ZM17.9714 7.62569C17.9286 6.96315 17.4209 6.46204 16.8314 6.50069C15.6904 6.64371 14.7287 7.52326 14.3714 8.75069H16.8314C17.4209 8.78934 17.9286 8.28823 17.9714 7.62569ZM7.97143 7.62569C8.01416 6.96315 8.52195 6.46204 9.11143 6.50069C10.2487 6.64786 11.2056 7.52666 11.5614 8.75069H9.11143C8.52195 8.78934 8.01416 8.28823 7.97143 7.62569ZM5.97143 11.0007C5.95943 11.0751 5.95943 11.1513 5.97143 11.2257V15.2757C5.95943 15.3501 5.95943 15.4263 5.97143 15.5007H11.9714V11.0007H5.97143ZM7.47141 17.7507H11.9714V22.2507H7.47141V17.7507ZM13.9714 17.7507V22.2507H18.4714V17.7507H13.9714Z",
		fill: "var(--main-color)"
	})]
});
export { SvgGift as ReactComponent };
